import { render, staticRenderFns } from "./jphomepage.vue?vue&type=template&id=03ced74b&"
import script from "./jphomepage.vue?vue&type=script&lang=js&"
export * from "./jphomepage.vue?vue&type=script&lang=js&"
import style0 from "./jphomepage.vue?vue&type=style&index=0&id=03ced74b&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ced74b')) {
      api.createRecord('03ced74b', component.options)
    } else {
      api.reload('03ced74b', component.options)
    }
    module.hot.accept("./jphomepage.vue?vue&type=template&id=03ced74b&", function () {
      api.rerender('03ced74b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/jphomepage.vue"
export default component.exports